export default "__VITE_ASSET__Bl4xk5PH__"